import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=c8970342&"
import script from "./Markets.vue?vue&type=script&lang=ts&"
export * from "./Markets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports